import { useAuth0 } from '@auth0/auth0-react';

const useOrganizationName = () => {
  const { user } = useAuth0();
  return user?.user_metadata?.organizationCode || null;
};

export default useOrganizationName;
